import React, { useEffect, useState,  } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Alert, Button, Card, Col, Divider, Row, Spin, Typography } from 'antd';
import { CheckOutlined, LinkOutlined, StopOutlined } from '@ant-design/icons';
import Title from 'antd/es/typography/Title';
import { MdEditOff } from 'react-icons/md';
import BtnSimpl from '../../components/buttons/BtnSimpl';
import './formulaires.css';
import { getFormById } from '../../redux/actions/GetFormFromIdActions';
import { useParams } from 'react-router-dom';
import ReponseCourte from '../../components/questionTypes/ReponseCourte';
import Paragraphe from '../../components/questionTypes/Paragraphe';
import ChoixMultiples from '../../components/questionTypes/ChoixMultiples';
import Checkboxes from '../../components/questionTypes/Checkboxes';
import UploadFichier from '../../components/questionTypes/UploadFichier';
import InputDate from '../../components/questionTypes/InputDate';
import InputHeure from '../../components/questionTypes/InputHeure';
import Emails from '../../components/questionTypes/Emails';
import Nombres from '../../components/questionTypes/Nombres';
import SelectListeDeroulant from '../../components/questionTypes/SelectListeDeroulant';
import ModalComponent from '../../components/modals/ModalComponent';


 
const { Text } = Typography;

const ViewFormEnregistree = () => {
  const dispatch = useDispatch();
  const [responses, setResponses] = useState({});
  const { id } = useParams();
  // console.log(id);

  const [selectedValueRadio, setSelectedValueRadio] = useState(null);
const [selectedValueListeDeroulant, setSelectedValueListeDeroulant] = useState(null);
const [selectedValueCheckbox, setSelectedValueCheckbox] = useState([]);
const [openModalCopie, setOpenModalCopie] = useState();

  const {
    loading: loadingFormById, form: formById, error, } = useSelector((state) => state.getFormById);

  const decodedId = atob(id); 

useEffect(() => {
  if (decodedId) {
    dispatch(getFormById(decodedId));
  }
}, [dispatch, decodedId]);

  
  const handleChange = (decodedId, value) => {
  setResponses(prev => ({
    ...prev,
    [decodedId]: value,
  }));
};


const handleRadioChange = (e) => {
  const clickedValue = e.target.value;
  setSelectedValueRadio(prev =>
    prev === clickedValue ? null : clickedValue
  );
};

const handleCheckboxChange = (e, option) => {
  const isChecked = e.target.checked;
  setSelectedValueCheckbox(prev => {
    if (isChecked) {
      return [...prev, option];
    } else {
      return prev.filter(o => o !== option);
    }
  });
};


const renderInputByType = (question) => {
  if (!question) return null;

  const { id, type, options = [] } = question;
  const value = responses[id]; 

  switch (type) {
    case 'text':
      return <ReponseCourte disabled={false} value={value} onChange={(val) => handleChange(id, val)} />;
    case 'textarea':
      return <Paragraphe disabled={false} value={value} onChange={(val) => handleChange(id, val)} />;
    case 'radio':
      return <ChoixMultiples editable={false} options={options}  onChange={handleRadioChange} value={selectedValueRadio} disabled={false}  />;
    case 'checkbox':
      return <Checkboxes editable={false} options={options}  value={selectedValueCheckbox} onChange={handleCheckboxChange}  disabled={false} />;
    case 'select':
      return <SelectListeDeroulant options={options}  value={selectedValueListeDeroulant} onChange={(val) => { setSelectedValueListeDeroulant(val); handleChange(id, val); }} disabled={false} />;
    case 'file':
      return <UploadFichier disabled={false} value={value} onChange={(val) => handleChange(id, val)} />;
    case 'date':
      return <InputDate disabled={false} value={value} onChange={(val) => handleChange(id, val)} />;
    case 'time':
      return <InputHeure disabled={false} value={value} onChange={(val) => handleChange(id, val)} />;
    case 'email':
      return <Emails disabled={false} value={value} onChange={(val) => handleChange(id, val)} />;
    case 'number':
      return <Nombres disabled={false} value={value} onChange={(val) => handleChange(id, val)} />;
    default:
      return null;
  }
};

const handleResetValues = () => {
  setResponses({});
  setSelectedValueCheckbox([]);
  setSelectedValueListeDeroulant(null);
  setSelectedValueRadio(null);
};

const handleOpenModalCopie = () =>  {
  setOpenModalCopie(true);
}
const handleCloseModalCopie = () => {
  setOpenModalCopie(false);
}
const isDisabled = (formById?.form?.shareUrl === null || formById?.form?.shareUrl === undefined ); 

  return (
    <div className="divGFormPrv">
      <div className="stylDivTop">
        <Row justify="center">
          <Col span={4} style={{ marginLeft: "-6.5%" }}>
            <Title level={4}>Formulaire enregistré</Title>
          </Col>
          <Col span={19} className="stylColRight">
            {formById?.form?.isPublished === true && (<Title level={5} style={{ margin: 0 }}><CheckOutlined /> Déja publié</Title>)}
             {formById?.form?.isPublished === false && (<Title level={5} style={{ margin: 0 }}><StopOutlined /> Non publié</Title>)}

            <BtnSimpl
              padding_="7%"
              boldColor_={500}
              buttonText_="Copier le lien pour les répondants"
              htmlType_="button"
              border_={true}
              prefix_={<LinkOutlined />}
              cursor_={isDisabled ? 'not-allowed' : 'pointer'}
              color_= {isDisabled ? '#C6C6C6' : '#43CE0C'}
              onClick_={() => { if (!isDisabled) {handleOpenModalCopie();} }}
            />
          </Col>
          <Col span={23}>
            <Alert
              icon={<MdEditOff />}
              showIcon
              message="Ce formulaire n'accepte pas de réponses."
              type="warning"
              style={{ border: 'none', textAlign: 'left' }}
            />
          </Col>
        </Row>
      </div>

      <div className="stylDivContent">
        <br />
        {loadingFormById ? (
          <Spin className="spinLoading" size="large" tip="Chargement du formulaire..." />
        ) : error ? (
          <p style={{ color: 'red', textAlign: 'center' }}>{error}</p>
        ) : formById?.form ? (
          <>
            <Row justify="center" style={{ marginBottom: '1.2%' }}>
              <Col span={12}>
                <Card className="stylCardTitleDesc">
                  <div style={{ textAlign: 'left' }}>
                    <Title level={2} style={{ margin: 0 }}>
                      {formById?.form.title || 'Formulaire sans titre'}
                    </Title>
                    <Title level={4}>
                      {formById?.form.description || 'Description du formulaire'}
                    </Title>
                  </div>
                </Card>
              </Col>
            </Row>
            <Row justify="center">
              <Col span={12}>
               {formById?.form.fields?.map((q, index) => (
                <Card key={`${q.id}-${index}`} style={{ marginBottom: '2.5%', textAlign: 'left' }}>
                  <span style={{ fontSize: '12pt' }}>
                    {q.label || `Question ${index + 1}`}
                  </span>
                  <div style={{ marginTop: 8 }}>{renderInputByType(q)}</div>
                </Card>
              ))
              }

              </Col>
            </Row>
            <Row justify="center">
              <Col
                span={12}
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <Button
                  disabled
                  style={{ border: 'none', fontWeight: 600 }}
                  title="Impossible d'envoyer des formulaires en mode aperçu"
                >
                  Envoyer
                </Button>
                <Button
                  type="text"
                  style={{ color: '#43CE0C', fontWeight: 600 }}
                  onClick={handleResetValues}
                >
                  Effacer le formulaire
                </Button>
              </Col>
            </Row>
            <br/>
            <br/>
          </>
        ) : (
          <p style={{ textAlign: 'center', marginTop: 50 }}>
            Aucun formulaire à afficher.
          </p>
        )}
      </div>

        {/* LES MODALES */}

          <div style={{width:"100%"}}>
                                    <ModalComponent 
                                        _title={<> 
                                       <div> Copier le lien pour les répondants</div>
                                        </>}
                                        _zIndex={1100}  
                                        _width="30%"
                                        // _top="60%"
                                        _padding={0}
                                        _maskClosable={false}
                                        _closable={true} 
                                        _open={openModalCopie}
                                        _onCancel={handleCloseModalCopie}
                                        _form={ 
                                          <div style={{marginTop:"2%"}}>
                                              <>
                                              <div> <a rel="noopener noreferrer" target='_blank' href={formById?.form?.shareUrl} >{formById?.form?.shareUrl}</a></div>
                                            <Divider style={{marginTop:12, marginBottom:15}} />
                                            <div ><Text style={{fontSize:"30px", textAlign:"right"}} className="stylCopyText" copyable={{ text: formById?.form?.shareUrl }}></Text></div><br/></>
                                          </div>
                                        }
                                    />
                  </div> 


    </div>
  );
};

export default ViewFormEnregistree;
